'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var states = {};

var State = function () {
  function State(state) {
    _classCallCheck(this, State);

    this.state = {};
    this.listeners = {};

    this.state = state;
  }

  _createClass(State, [{
    key: '_isEqual',
    value: function _isEqual(key, val) {
      var oldVal = this.state[key];
      return oldVal === val;
    }
  }, {
    key: '_notifiy',
    value: function _notifiy(key) {
      var _this = this;

      var listeners = this.listeners[key] || [];
      listeners.forEach(function (listener) {
        listener(_this.state[key]);
      });
    }
  }, {
    key: 'update',
    value: function update(key, val) {
      if (this._isEqual(key, val)) {
        console.log('values are equal so skipping change');
        return;
      }
      this.state[key] = val;
      this._notifiy(key);
    }
  }, {
    key: 'get',
    value: function get(key) {
      return this.state[key] || this.state;
    }
  }, {
    key: 'observe',
    value: function observe(key, cb) {
      var listeners = this.listeners[key] || [];
      listeners.push(cb);
      this.listeners[key] = listeners;
      console.log('Observers for ', key, listeners.length);
    }
  }, {
    key: 'destroy',
    value: function destroy(key, cb) {
      var listeners = this.listeners[key];
      var index = cb ? listeners.indexOf(cb) : listeners = [];
      if (index !== -1) {
        listeners.splice(index, 1);
      }
    }
  }]);

  return State;
}();

var StateProvider = exports.StateProvider = {
  createState: function createState(name, state) {
    var newState = states[name] || new State(state);
    states[name] = newState;
    return newState;
  },
  getState: function getState(name) {
    return states[name];
  },
  destroy: function destroy(name) {
    states[name] = null;
  }
};


//////////////////
// WEBPACK FOOTER
// ./state.provider.js
// module id = 0
// module chunks = 0